import { ElementId } from '~/features/shared/ad/types'

export const pcMemberDetailAds = [
  'adContentBottomLeft',
  'adContentBottomRight',
] satisfies ElementId[]
